import React, { useState, useEffect } from 'react';
import axios from 'axios';

function SearchForm({ onLocationSelected, loading }) {
  const [query, setQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      // Only fetch if the query isn't empty and doesn't exactly match a selected location
      if (query.length > 2 && showDropdown) {
        try {
          const res = await axios.get('https://nominatim.openstreetmap.org/search', {
            params: {
              q: query,
              format: 'json',
              addressdetails: 1,
              limit: 5,
              countrycodes: 'us'
            }
          });
          setSuggestions(res.data);
        } catch (err) {
          console.error("Autocomplete error:", err);
        }
      } else {
        setSuggestions([]);
      }
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [query, showDropdown]);

  const handleSelect = (item) => {
    // 1. Update the text to the clean version
    setQuery(item.display_name);
    // 2. IMMEDIATELY hide the dropdown and clear suggestions
    setShowDropdown(false);
    setSuggestions([]);
    // 3. Trigger the weather fetch
    onLocationSelected(item.lat, item.lon, item.display_name);
  };

  const handleInputChange = (e) => {
    setQuery(e.target.value);
    setShowDropdown(true); // Re-enable dropdown when user starts typing again
  };

  return (
    <div className="search-form">
      <div className="app-branding">
        <h1 className="app-name" onClick={() => window.location.reload()} style={{ cursor: 'pointer' }}>WeatherBetter</h1>
      </div>
      <div className="input-group">
        <label>Search Location</label>
        <div className="autocomplete-wrapper">
          <input
            type="text"
            value={query}
            onChange={handleInputChange}
            placeholder="Search City, State..."
            autoComplete="off" // Prevents browser's own popup
            name="nws-search-unique" // Unique name helps avoid cache
          />
          
          {/* Only show if showDropdown is true and we have suggestions */}
          {showDropdown && suggestions.length > 0 && (
            <ul className="suggestions-list">
              {suggestions.map((item, index) => (
                <li key={index} onClick={() => handleSelect(item)}>
                  {item.display_name}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}

export default SearchForm;